<!-- Filters grouped with 2-level hierarchy -->
<div *ngIf="store.filterGroupSettings$ | async as filterGroupData" class="general-filter-container">
    <nb-accordion [multi]="true" class="accordion" [formGroup]="store.filtersFormGroup">
        <!-- One accordion item for every group -->
        <nb-accordion-item *ngFor="let groupItem of filterGroupData" class="general-filter">
            <nb-accordion-item-header class="group-header">
                <div class="accordion-header-right">
                    <span class="title">{{ groupItem.groupLabel }}</span>
                    <span [class.alert-badge]="isFilterAppliedInGroup(groupItem)"></span>
                </div>
            </nb-accordion-item-header>

            <!-- One filter group contains multiple filters -->
            <nb-accordion-item-body class="accordion-body">
                <nb-accordion-item *ngFor="let filterItem of groupItem.filters" class="general-filter">
                    <nb-accordion-item-header class="filter-header">
                        <div class="accordion-header-right">
                            <span class="title">{{ filterItem.fieldName }}</span>
                            <span [class.alert-badge]="isFilterApplied(groupItem.groupKey, filterItem)"></span>
                        </div>
                    </nb-accordion-item-header>

                    <nb-accordion-item-body class="accordion-body">
                        <!-- DATE RANGE FILTER: works for date and datetime range -->
                        <div *ngIf="FilterType.isDateRangeFilterType(filterItem.webFilterType)">
                            <ngx-date-range-picker
                                [formControlName]="filterItem.fieldKey"
                                [convertDateTimezone]="false"
                                [dateWithTime]="filterItem.webFilterType === FilterType.DatetimeRange"
                            ></ngx-date-range-picker>
                        </div>

                        <!-- MULTISELECT DROP DOWN -->
                        <div *ngIf="FilterType.isSelectFilterType(filterItem.webFilterType)">
                            <ngx-simple-checkbox-group
                                *ngIf="
                                    filterItem.webFilterType === FilterType.MultiSelect ||
                                    filterItem.webFilterType === FilterType.MultiSelectAutocomplete
                                "
                                [formControlName]="filterItem.fieldKey"
                                [options]="filterItem.options"
                                [searchEnabled]="
                                    filterItem.webFilterType === FilterType.MultiSelectAutocomplete ?? true
                                "
                                [selectAllEnabled]="
                                    filterItem.webFilterType === FilterType.MultiSelectAutocomplete ?? true
                                "
                            ></ngx-simple-checkbox-group>

                            <!-- TODO: Need to add autocomplete APIs -->
                            <ngx-api-checkbox-group
                                *ngIf="filterItem.webFilterType === FilterType.MultiSelectAutocompleteApi"
                                [formControlName]="filterItem.fieldKey"
                                [options]="filterItem.options"
                                [initialState]="store.getFilterState(filterItem.fieldKey)"
                                (stateChange)="handleStateChangeSelect($event, filterItem)"
                            ></ngx-api-checkbox-group>
                        </div>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
</div>

<!--
<div
    *ngIf="!(store.filterGroupSettings$ | async)"
    [nbSpinner]="!(store.filterGroupSettings$ | async)"
    class="spinner-container"
></div>
-->
